import { splitArrayArrange } from "../Pages/Orders/orderTypes";

const formatPlanningExtraItems = (
  customizedData: any[],
  planningItems: any[],
  planningId?: any,
) => {
  let resultData = [...(customizedData || [])];

  const extraItems = (planningItems || []).filter(
    (pi: any) =>
      (pi.item_type === "advertisement_sign" || pi.item_type === "load_notice") &&
      !resultData.some(
        (cd: any) => cd.item_id?.toString() === pi._id?.toString(),
      ),
  );

  extraItems.forEach((pi: any) => {
    const productName =
      pi.name ||
      pi.product?.name ||
      (pi.item_type === "advertisement_sign"
        ? "Advertisement Sign"
        : "Load Notice");
    const qty = pi.quantity || pi.product?.quantity || 0;
    const productRow = {
      product_id: pi._id || pi.item_type,
      product_name: productName,
      description: "",
      variants: {
        variant_id: pi._id || pi.item_type,
        variant_name: productName,
        quantity: qty,
        attributes: {},
      },
      spacifications: "",
      attributes: {},
      unit_price: 0,
      variant_qty: qty,
      total_price: 0,
      image: null,
    };
    const catSnap = pi.categories_snapshot || {
      _id: pi.item_type || "advertisement_sign",
      category_id: pi.item_type || "advertisement_sign",
      name: productName,
      slug: pi.item_type
        ? pi.item_type.replace(/_/g, "-")
        : "advertisement-sign",
      image: null,
    };
    const splits = pi.splits || [];
    splits.forEach((split: any, index: number) => {
      resultData.push({
        ...split,
        planing_id: planningId || null,
        department_id: split?.department_id ? split?.department_id : null,
        machine_id: split?.machine_id ? split?.machine_id : null,
        key: resultData.length + index,
        product: productRow,
        item_id: pi._id,
        item_type: pi.item_type,
        name: pi.name,
        categories_snapshot: catSnap,
        drawings: pi.drawings || [],
        variant_name: pi.variant_name || productName,
        rowSpan: index === 0 ? splits.length : 0,
      });
    });
  });

  return resultData;
};

//Reducer Types
interface State {
  orderListData: any;
  ordersCount: number;
  orderDetails: any;
  productionPlanData?: any;
  productionCalender?: any;
  CreatedByData?: any;
  CompanyData?: any;
  orderDetailsForClient?: any;
  dispatchPlaningDetails?: any;
  mezzanineDispatchPlaningDetails?: any;
  manufacturingProductsList?: any;
  manufacturingProductsDetails?: any;
  manufacturingProductionLogs?: any;
  getOrderProductionDepartment?: any;
  productionJobsData?: any;
  JobProductionUniqueDepartment?: any;
  JobProductionUniqueMachine?: any;
  JobProductionUniqueEmployee?: any;
  productionCategories?: any[];
  printedJobLabelData?: any;
  lastWarningEvent?: any;
}

const isSameOrder = (existingState: any, incomingPayload: any) => {
  if (!existingState || !incomingPayload) return false;
  const existingIds = [
    existingState._id ? String(existingState._id) : null,
    existingState.order_id ? String(existingState.order_id) : null,
  ].filter(Boolean);

  const incomingIds = [
    incomingPayload._id ? String(incomingPayload._id) : null,
    incomingPayload.order_id ? String(incomingPayload.order_id) : null,
  ].filter(Boolean);

  return existingIds.some((id) => incomingIds.includes(id));
};

const mergeOrderDetails = (existingOrderDetails: any, incomingOrderDetails: any) => {
  if (!existingOrderDetails) return incomingOrderDetails;
  if (!incomingOrderDetails) return existingOrderDetails;

  const isHex24 = (val: any) => typeof val === "string" && /^[0-9a-fA-F]{24}$/.test(val);

  const preservedOrderId = isHex24(incomingOrderDetails?.order_id)
    ? (existingOrderDetails?.order_id || incomingOrderDetails?.order_id)
    : (incomingOrderDetails?.order_id || existingOrderDetails?.order_id);

  const preservedDisplayQuoteId =
    incomingOrderDetails?.display_quote_id ||
    existingOrderDetails?.display_quote_id ||
    (!isHex24(existingOrderDetails?.quote_id) ? existingOrderDetails?.quote_id : undefined);

  const preservedQuoteId = preservedDisplayQuoteId ||
    (!isHex24(incomingOrderDetails?.quote_id) ? incomingOrderDetails?.quote_id : existingOrderDetails?.quote_id);

  const preservedObjQuoteId =
    incomingOrderDetails?.obj_quote_id ||
    (isHex24(incomingOrderDetails?.quote_id) ? incomingOrderDetails?.quote_id : existingOrderDetails?.obj_quote_id);

  const preservedCustomerId =
    (incomingOrderDetails?.customer_id && typeof incomingOrderDetails?.customer_id === "object" && incomingOrderDetails?.customer_id?.company_name)
      ? incomingOrderDetails.customer_id
      : (existingOrderDetails?.customer_id || incomingOrderDetails?.customer_id);

  const existingSnapshot = existingOrderDetails?.customer_snapshot;
  const incomingSnapshot = incomingOrderDetails?.customer_snapshot;
  let mergedSnapshot = incomingSnapshot ? { ...incomingSnapshot } : existingSnapshot;

  if (mergedSnapshot && existingSnapshot) {
    const isPopulatedQuoteFor = (q: any) => q && typeof q === "object" && (q.name || q.label || q.title);
    const quoteFor = isPopulatedQuoteFor(incomingSnapshot?.quote_for)
      ? incomingSnapshot.quote_for
      : (existingSnapshot.quote_for || incomingSnapshot?.quote_for);

    const salespersonId = (incomingSnapshot?.salesperson_id && typeof incomingSnapshot?.salesperson_id === "object")
      ? incomingSnapshot.salesperson_id
      : (existingSnapshot.salesperson_id || incomingSnapshot?.salesperson_id);

    const additionalContact = (incomingSnapshot?.additional_account_contact_id && typeof incomingSnapshot?.additional_account_contact_id === "object")
      ? incomingSnapshot.additional_account_contact_id
      : (existingSnapshot.additional_account_contact_id || incomingSnapshot?.additional_account_contact_id);

    mergedSnapshot = {
      ...existingSnapshot,
      ...incomingSnapshot,
      quote_for: quoteFor,
      salesperson_id: salespersonId,
      additional_account_contact_id: additionalContact,
    };
  }

  const existingBom = existingOrderDetails?.bom_details;
  const preserveBom = Array.isArray(existingBom) && existingBom.length > 0;

  return {
    ...existingOrderDetails,
    ...incomingOrderDetails,
    order_id: preservedOrderId,
    quote_id: preservedQuoteId,
    display_quote_id: preservedDisplayQuoteId,
    obj_quote_id: preservedObjQuoteId,
    customer_id: preservedCustomerId,
    customer_snapshot: mergedSnapshot,
    bom_details: preserveBom ? existingBom : (incomingOrderDetails?.bom_details || []),
    invoice_warnings: existingOrderDetails?.invoice_warnings !== undefined
      ? existingOrderDetails.invoice_warnings
      : incomingOrderDetails?.invoice_warnings,
    drop_tbc_warnings: existingOrderDetails?.drop_tbc_warnings !== undefined
      ? existingOrderDetails.drop_tbc_warnings
      : incomingOrderDetails?.drop_tbc_warnings,
  };
};

export const ordersReducer = (
  state: State = {
    orderListData: [],
    ordersCount: 0,
    orderDetails: null,
    lastWarningEvent: null,
    productionPlanData: [],
    productionCalender: [],
    CreatedByData: [],
    CompanyData: [],
    orderDetailsForClient: null,
    dispatchPlaningDetails: null,
    mezzanineDispatchPlaningDetails: null,
    manufacturingProductsList: [],
    manufacturingProductsDetails: null,
    manufacturingProductionLogs: [],
    getOrderProductionDepartment: [],
    productionJobsData: [],
    JobProductionUniqueDepartment: [],
    JobProductionUniqueMachine: [],
    JobProductionUniqueEmployee: [],
    productionCategories: [],
    printedJobLabelData: [],
  },
  action: any,
): State => {
  switch (action.type) {
    case "GET_ORDERS_DATA":
      console.log(action.payload, "action.payload");
      return {
        ...state,
        orderListData:
          action.payload.page == 1 || !action.payload.page
            ? action.payload?.data
            : [...state?.orderListData, ...action.payload?.data],
        ordersCount: action.payload.count,

        // detail:action.payload.detail
      };
    case "GET_ORDERS_DETAILS": {
      const same = isSameOrder(state.orderDetails, action.payload);
      if (!same) {
        return {
          ...state,
          orderDetails: action.payload,
        };
      }

      return {
        ...state,
        orderDetails: mergeOrderDetails(state.orderDetails, action.payload),
      };
    }
    case "GET_ORDER_BOM_REGENARATE_SUCCESS":
    case "GET_ORDER_BOM_REGENERATE_SUCCESS": {
      const same = isSameOrder(state.orderDetails, action.payload);
      const baseOrder = same
        ? state.orderDetails
        : (state.orderDetails ? state.orderDetails : action.payload);

      return {
        ...state,
        orderDetails: baseOrder
          ? {
              ...baseOrder,
              bom_details:
                action.payload?.bom_details !== undefined
                  ? action.payload.bom_details
                  : (baseOrder.bom_details || []),
              invoice_warnings:
                action.payload?.invoice_warnings !== undefined
                  ? action.payload.invoice_warnings
                  : baseOrder.invoice_warnings,
              drop_tbc_warnings:
                action.payload?.drop_tbc_warnings !== undefined
                  ? action.payload.drop_tbc_warnings
                  : baseOrder.drop_tbc_warnings,
              is_variable_confirmation_completed:
                action.payload?.is_variable_confirmation_completed !== undefined
                  ? action.payload.is_variable_confirmation_completed
                  : baseOrder.is_variable_confirmation_completed,
            }
          : action.payload,
        lastWarningEvent: {
          ...action.payload,
          timestamp: Date.now(),
        },
      };
    }
    case "GET_ORDER_BOM_AND_WARNINGS_SUCCESS": {
      const same = isSameOrder(state.orderDetails, action.payload);
      const mergedOrder = same
        ? mergeOrderDetails(state.orderDetails, action.payload)
        : (state.orderDetails ? state.orderDetails : action.payload);

      return {
        ...state,
        orderDetails: mergedOrder
          ? {
              ...mergedOrder,
              bom_details:
                action.payload?.bom_details !== undefined
                  ? action.payload.bom_details
                  : (mergedOrder.bom_details || []),
              invoice_warnings:
                action.payload?.invoice_warnings !== undefined
                  ? action.payload.invoice_warnings
                  : mergedOrder.invoice_warnings,
              drop_tbc_warnings:
                action.payload?.drop_tbc_warnings !== undefined
                  ? action.payload.drop_tbc_warnings
                  : mergedOrder.drop_tbc_warnings,
              is_variable_confirmation_completed:
                action.payload?.is_variable_confirmation_completed !== undefined
                  ? action.payload.is_variable_confirmation_completed
                  : mergedOrder.is_variable_confirmation_completed,
            }
          : action.payload,
        lastWarningEvent: {
          ...action.payload,
          timestamp: Date.now(),
        },
      };
    }
    case "DELETE_ORDER":
      return {
        ...state,
        orderListData: state?.orderListData?.filter(
          (elem: any) => elem?._id !== action?.payload,
        ),
        ordersCount: state?.ordersCount - 1,
      };
    case "GET_ORDERS_PRODUCTION_PLAN": {
      const customizedData = action.payload?.customized_data || [];
      const planningItems = action.payload?.planning?.items || [];
      const planningId = action.payload?.planning?._id;

      return {
        ...state,
        productionPlanData: formatPlanningExtraItems(
          customizedData,
          planningItems,
          planningId,
        ),
        productionCategories: action.payload?.categories_snapshot || [],
      };
    }

    case "ADDED_LOG_FROM_PRODUCTION": {
      return {
        ...state,
        productionPlanData: state?.productionPlanData?.map((elem: any) => {
          if (elem?._id == action?.payload?.id) {
            const newManQty = elem?.manufactured_qty + action?.payload?.qty;
            const newPendQty = elem?.pending_qty - action?.payload?.qty;
            const isOrderCompleted = newManQty == elem?.qty;
            return {
              ...elem,
              manufactured_qty: newManQty,
              status: isOrderCompleted ? "completed" : "started",
              pending_qty: newPendQty,
            };
          }
          return elem;
        }),
      };
    }
    case "UPDATE_PRODUCTION_DATES_DATE": {
      const updatedPlanning = action.payload || {};
      const updatedItems = updatedPlanning?.items || [];

      let updatedPlanData = state?.productionPlanData;

      if (
        Array.isArray(state?.productionPlanData) &&
        state.productionPlanData.length > 0 &&
        Array.isArray(updatedItems) &&
        updatedItems.length > 0
      ) {
        updatedPlanData = state.productionPlanData.map((row: any) => {
          if (!row) return row;

          let matchingSplit: any = null;
          for (const item of updatedItems) {
            if (Array.isArray(item.splits)) {
              const found = item.splits.find(
                (sp: any) => sp?._id?.toString() === row?._id?.toString(),
              );
              if (found) {
                matchingSplit = found;
                break;
              }
            }
          }

          if (matchingSplit) {
            return {
              ...row,
              start_at: matchingSplit.start_at,
              end_at: matchingSplit.end_at,
              status: matchingSplit.status || row.status,
              manufactured_qty:
                matchingSplit.manufactured_qty ?? row.manufactured_qty,
              pending_qty: matchingSplit.pending_qty ?? row.pending_qty,
              employee_ids: matchingSplit.employee_ids || row.employee_ids,
              quality_checklists:
                matchingSplit.quality_checklists || row.quality_checklists,
            };
          }
          return row;
        });
      } else if (
        (!state?.productionPlanData || state.productionPlanData.length === 0) &&
        Array.isArray(updatedItems) &&
        updatedItems.length > 0
      ) {
        updatedPlanData = formatPlanningExtraItems(
          [],
          updatedItems,
          updatedPlanning._id,
        );
      }

      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          planning_details: {
            ...state.orderDetails?.planning_details,
            ...updatedPlanning,
          },
        },
        productionPlanData: updatedPlanData,
      };
    }
    case "SPLIT_PRODUCT_SUCCESS": {
      const payloadObj = Array.isArray(action.payload)
        ? { customized_data: action.payload, planning: null }
        : action.payload || {};

      const customizedData = payloadObj?.customized_data || [];
      const planningItems = payloadObj?.planning?.items || [];
      const planningId = payloadObj?.planning?._id;

      return {
        ...state,
        productionPlanData: formatPlanningExtraItems(
          customizedData,
          planningItems,
          planningId,
        ),
      };
    }
    case "CHANGE_ORDER_STATUS":
      return {
        ...state,
        orderDetails: {
          ...state?.orderDetails,
          order_status: action.payload?.status,
          dispatched_details: action?.payload?.dispatched_details
            ? action?.payload?.dispatched_details
            : state?.orderDetails?.dispatched_details,
        },
      };
    case "GET_ORDERS_PRODUCTION_PLAN_CALENDER_DATA":
      return {
        ...state,
        productionCalender: action?.payload,
      };
    case "GET_ORDERS_FILTER_DATA":
      return {
        ...state,
        CreatedByData: action?.payload?.CreatedByData,
        CompanyData: action?.payload?.CompanyData,
      };

    case "UPDATE_PRODUCTION_PLAN_PRODUCT":
      return {
        ...state,
        productionPlanData: state?.productionPlanData?.map((elem: any) => {
          if (elem?._id == action.payload?._id) {
            return action.payload;
          }
          return elem;
        }),
      };
    case "UPDATE_ORDER_ID":
      return {
        ...state,
        orderDetails: { ...state?.orderDetails, order_id: action.payload },
      };
    case "UPDATE_ORDER_PAYMENT_MILESTONE":
      return {
        ...state,
        orderDetails: {
          ...state?.orderDetails,
          payment_milestones: state?.orderDetails?.payment_milestones?.map(
            (m: any) => (m._id === action.payload._id ? action.payload : m),
          ),
        },
      };
    case "UPDATE_ORDER_PAYMENT_MILESTONES_LIST":
      return {
        ...state,
        orderDetails: {
          ...state?.orderDetails,
          payment_milestones: action.payload,
        },
      };
    case "SEND_CLIENT_DISPATCH_MAIL":
      return {
        ...state,
        orderDetails: {
          ...state?.orderDetails,
          sent_mails: { installation_instruction: true },
        },
      };
    case "GET_ORDERS_DETAILS_FOR_CLIENT":
      return {
        ...state,
        orderDetailsForClient: action.payload,
      };

    case "GET_ORDERS_DISPATCH_PLANNING_DETAILS":
      return {
        ...state,
        dispatchPlaningDetails: action.payload,
      };
    case "GET_MEZZANINE_ORDERS_DISPATCH_PLANNING_DETAILS":
      return {
        ...state,
        mezzanineDispatchPlaningDetails: action.payload,
      };
    case "UPDTAE_DISPATCH_DATA":
      console.log(action.payload, "action.payload");
      if (
        action?.payload?.data &&
        typeof action.payload.data === "object" &&
        Array.isArray(action.payload.data.load_id)
      ) {
        return {
          ...state,
          dispatchPlaningDetails: action.payload.data,
        };
      }
      return {
        ...state,
        dispatchPlaningDetails: {
          ...state?.dispatchPlaningDetails,
          load_id: state?.dispatchPlaningDetails?.load_id?.map((l: any) =>
            l._id === action?.payload?.load_id
              ? {
                  ...l,
                  status: action?.payload?.status,
                  ...(action?.payload?.dispatch_checklist
                    ? { dispatch_checklist: action.payload.dispatch_checklist }
                    : {}),
                }
              : l,
          ),
        },
      };
    case "DISPATCH_EMPLOYEE_ADD":
      const findedEmployee = action?.payload?.data?.load_id?.find(
        (elem: any) => elem?._id == action?.payload?.load_id,
      )?.employee_ids;
      const newLoadData = action?.payload?.for_all_loads
        ? state?.dispatchPlaningDetails?.load_id?.map((elem: any) => {
            return {
              ...elem,
              employee_ids: findedEmployee,
            };
          })
        : state?.dispatchPlaningDetails?.load_id?.map((elem: any) => {
            if (elem?._id === action?.payload?.load_id) {
              return {
                ...elem,
                employee_ids: findedEmployee,
              };
            }
            return elem;
          });
      return {
        ...state,
        dispatchPlaningDetails: {
          ...state?.dispatchPlaningDetails,
          load_id: newLoadData,
        },
      };
    case "GET_MANUFACTURING_PRODUCTS_LIST":
      return {
        ...state,
        manufacturingProductsList:
          action.payload?.page > 1
            ? [
                ...(state?.manufacturingProductsList || []),
                ...(action.payload?.data || []),
              ]
            : action.payload?.data || [],
      };
    case "GET_MANUFACTURING_PRODUCTS_DETAILS":
      return {
        ...state,
        manufacturingProductsDetails: action.payload,
      };
    case "GET_MANUFACTURING_PRODUCTION_LOGS":
      return {
        ...state,
        manufacturingProductionLogs:
          action.payload?.page > 1
            ? [
                ...(state?.manufacturingProductionLogs || []),
                ...(action.payload?.data || []),
              ]
            : action.payload?.data || [],
      };
    case "ADD_ORDER_PRODUCTION_LOG": {
      const updatedStatus =
        action?.payload?.productionStatus || action?.payload?.status;

      const newDepartments =
        updatedStatus == "completed" &&
        state?.JobProductionUniqueDepartment?.length > 0
          ? state?.JobProductionUniqueDepartment?.map((elem: any) => {
              if (elem?._id == action?.payload?.department_id) {
                return {
                  ...elem,
                  incomplete_count: elem?.incomplete_count - 1,
                  complete_count: elem?.complete_count + 1,
                };
              }
              return elem;
            })
          : state?.JobProductionUniqueDepartment;

      const addMfgQty = action?.payload?.manufactured_qty || 0;

      return {
        ...state,
        JobProductionUniqueDepartment: newDepartments,
        productionPlanData: state?.productionPlanData?.map((elem: any) => {
          const splitId =
            elem?._id?.toString() ||
            elem?.splits_id?.toString() ||
            elem?.key?.toString();
          const targetSplitId = action?.payload?.splits_id?.toString();
          if (
            splitId === targetSplitId ||
            elem?._id?.toString() === targetSplitId
          ) {
            return {
              ...elem,
              status: updatedStatus || elem?.status,
              manufactured_qty:
                addMfgQty > 0
                  ? (elem?.manufactured_qty || 0) + addMfgQty
                  : elem?.manufactured_qty,
              pending_qty:
                addMfgQty > 0
                  ? (elem?.pending_qty || 0) - addMfgQty
                  : elem?.pending_qty,
            };
          }
          return elem;
        }),
        manufacturingProductsList: state?.manufacturingProductsList?.map(
          (elem: any) => {
            if (elem?._id == action?.payload?.production_planning_id) {
              if (elem?.items?.splits?._id === action?.payload?.splits_id) {
                return {
                  ...elem,
                  items: {
                    ...elem?.items,
                    splits: {
                      ...elem?.items?.splits,
                      status: updatedStatus || elem?.items?.splits?.status,
                      manufactured_qty:
                        (elem?.items?.splits?.manufactured_qty || 0) + addMfgQty,
                      pending_qty:
                        (elem?.items?.splits?.pending_qty || 0) - addMfgQty,
                    },
                  },
                };
              }
            }
            return elem;
          },
        ),
        manufacturingProductsDetails:
          (state?.manufacturingProductsDetails?._id?.toString() ==
            action?.payload?.production_planning_id?.toString() ||
            state?.manufacturingProductsDetails?.items?.splits?._id?.toString() ==
              action?.payload?.splits_id?.toString())
            ? {
                ...state?.manufacturingProductsDetails,
                items: {
                  ...state?.manufacturingProductsDetails?.items,
                  splits: {
                    ...state?.manufacturingProductsDetails?.items?.splits,
                    status:
                      updatedStatus ||
                      state?.manufacturingProductsDetails?.items?.splits?.status,
                    start_at:
                      updatedStatus === "started"
                        ? state?.manufacturingProductsDetails?.items?.splits
                            ?.start_at || new Date().toISOString()
                        : updatedStatus === "scheduled"
                        ? null
                        : state?.manufacturingProductsDetails?.items?.splits?.start_at,
                    end_at:
                      updatedStatus === "completed"
                        ? new Date().toISOString()
                        : updatedStatus === "scheduled"
                        ? null
                        : state?.manufacturingProductsDetails?.items?.splits?.end_at,
                    manufactured_qty:
                      (state?.manufacturingProductsDetails?.items?.splits
                        ?.manufactured_qty || 0) + addMfgQty,
                    pending_qty:
                      (state?.manufacturingProductsDetails?.items?.splits
                        ?.pending_qty || 0) - addMfgQty,
                  },
                },
              }
            : state?.manufacturingProductsDetails,
      };
    }
    case "EDIT_ORDER_PRODUCTION_LOG":
      const newEditDepartments =
        action.payload?.productionStatus == "completed" &&
        state?.JobProductionUniqueDepartment?.length > 0
          ? state?.JobProductionUniqueDepartment?.map((elem: any) => {
              if (elem?._id == action?.payload?.department_id) {
                return {
                  ...elem,
                  incomplete_count: elem?.incomplete_count - 1,
                  complete_count: elem?.complete_count + 1,
                };
              }
              return elem;
            })
          : state?.JobProductionUniqueDepartment;
      return {
        ...state,
        JobProductionUniqueDepartment: newEditDepartments,
        manufacturingProductsList: state?.manufacturingProductsList?.map(
          (elem: any) => {
            if (elem?._id == action?.payload?.production_planning_id) {
              if (elem?.items?.splits?._id === action?.payload?.splits_id) {
                return {
                  ...elem,
                  items: {
                    ...elem?.items,
                    splits: {
                      ...elem?.items?.splits,
                      status: action?.payload?.productionStatus,
                      manufactured_qty:
                        elem?.items?.splits?.manufactured_qty +
                        action?.payload?.diff_qty,
                      pending_qty:
                        elem?.items?.splits?.pending_qty -
                        action?.payload?.diff_qty,
                    },
                  },
                };
              }
            }
            return elem;
          },
        ),
        manufacturingProductsDetails:
          (state?.manufacturingProductsDetails?._id?.toString() ==
            action?.payload?.production_planning_id?.toString() ||
            state?.manufacturingProductsDetails?.items?.splits?._id?.toString() ==
              action?.payload?.splits_id?.toString())
            ? {
                ...state?.manufacturingProductsDetails,
                items: {
                  ...state?.manufacturingProductsDetails?.items,
                  splits: {
                    ...state?.manufacturingProductsDetails?.items?.splits,
                    status: action?.payload?.productionStatus,
                    manufactured_qty:
                      state?.manufacturingProductsDetails?.items?.splits
                        ?.manufactured_qty + action?.payload?.diff_qty,
                    pending_qty:
                      state?.manufacturingProductsDetails?.items?.splits
                        ?.pending_qty - action?.payload?.diff_qty,
                  },
                },
              }
            : state?.manufacturingProductsDetails,
      };
    case "DELETE_ORDER_PRODUCTION_LOG":
      const deletedLog = state?.manufacturingProductionLogs?.find(
        (l: any) => l._id === action.payload.log_id,
      );
      if (!deletedLog) return state;

      const removedQty = deletedLog.manufactured_qty;
      const planningId = deletedLog.production_planning_id;
      const splitsId = deletedLog.splits_id;

      const newDeleteDepartments =
        state?.JobProductionUniqueDepartment?.length > 0
          ? state?.JobProductionUniqueDepartment?.map((elem: any) => {
              if (elem?._id == action?.payload?.department_id) {
                return {
                  ...elem,
                  incomplete_count: elem?.incomplete_count + 1,
                  complete_count: elem?.complete_count - 1,
                };
              }
              return elem;
            })
          : state?.JobProductionUniqueDepartment;

      return {
        ...state,
        JobProductionUniqueDepartment: newDeleteDepartments,
        manufacturingProductionLogs: state?.manufacturingProductionLogs?.filter(
          (l: any) => l._id !== action.payload.log_id,
        ),
        manufacturingProductsList: state?.manufacturingProductsList?.map(
          (elem: any) => {
            if (elem?._id?.toString() == planningId?.toString()) {
              if (elem?.items?.splits?._id?.toString() === splitsId?.toString()) {
                return {
                  ...elem,
                  items: {
                    ...elem?.items,
                    splits: {
                      ...elem?.items?.splits,
                      status: action?.payload?.productionStatus,
                      manufactured_qty: Math.max(
                        0,
                        elem?.items?.splits?.manufactured_qty - removedQty,
                      ),
                      pending_qty:
                        elem?.items?.splits?.pending_qty + removedQty,
                    },
                  },
                };
              }
            }
            return elem;
          },
        ),
        manufacturingProductsDetails:
          (state?.manufacturingProductsDetails?._id?.toString() == planningId?.toString() ||
            state?.manufacturingProductsDetails?.items?.splits?._id?.toString() == splitsId?.toString())
            ? {
                ...state?.manufacturingProductsDetails,
                items: {
                  ...state?.manufacturingProductsDetails?.items,
                  splits: {
                    ...state?.manufacturingProductsDetails?.items?.splits,
                    status: action?.payload?.productionStatus,
                    manufactured_qty: Math.max(
                      0,
                      state?.manufacturingProductsDetails?.items?.splits
                        ?.manufactured_qty - removedQty,
                    ),
                    pending_qty:
                      state?.manufacturingProductsDetails?.items?.splits
                        ?.pending_qty + removedQty,
                  },
                },
              }
            : state?.manufacturingProductsDetails,
      };
    case "ADD_ORDER_PAYMENT_MILESTONE":
      return {
        ...state,
        orderDetails:
          state?.orderDetails?._id == action?.payload?.order_details?._id
            ? {
                ...state?.orderDetails,
                payment_milestones: action?.payload?.payment_milestones,
              }
            : state?.orderDetails,
      };
    case "GET_ORDER_PRODUCTION_DEPARTMENT":
      return {
        ...state,
        getOrderProductionDepartment: action?.payload,
      };
    case "GET_JOB_PRODUCTION_UNIQUE_DEPARTMENT":
      return {
        ...state,
        JobProductionUniqueDepartment: action?.payload?.departments,
        JobProductionUniqueMachine: action?.payload?.machines,
        JobProductionUniqueEmployee: action?.payload?.employees,
      };
    case "GET_PRODUCTION_JOBS_DATA":
      return {
        ...state,
        productionJobsData: action?.payload,
      };
    case "GET_PRINTED_JOB_LABEL_DATA":
      return {
        ...state,
        printedJobLabelData: action?.payload,
      };
    case "DELETE_MILESTONE_FROM_ORDER": {
      return {
        ...state,
        orderDetails: state?.orderDetails
          ? {
              ...state?.orderDetails,
              payment_milestones: action?.payload,
            }
          : state?.orderDetails,
      };
    }
    default:
      return state;
  }
};
